import {
  CACHE_SYNC_ERROR,
  CACHE_SYNC_REQUEST,
  CACHE_SYNC_RESET,
  CACHE_SYNC_SUCCESS,
} from "./ActionType";

export const initialState = {
  isRequest: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
  shopId: null,
  requestId: null,
};

const hasRequestMeta = (meta) =>
  meta?.shopId !== null &&
  meta?.shopId !== undefined &&
  typeof meta?.requestId === "string" &&
  meta.requestId.length > 0;

const isActiveRequest = (state, meta) =>
  hasRequestMeta(meta) &&
  state.shopId === String(meta.shopId) &&
  state.requestId === meta.requestId;

const cacheSyncReducer = (state = initialState, action) => {
  switch (action.type) {
    case CACHE_SYNC_REQUEST:
      if (!hasRequestMeta(action.meta)) return state;
      return {
        ...initialState,
        isRequest: true,
        shopId: String(action.meta.shopId),
        requestId: action.meta.requestId,
      };
    case CACHE_SYNC_SUCCESS:
      if (!isActiveRequest(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        data: action.payload,
        error: null,
      };
    case CACHE_SYNC_ERROR:
      if (!isActiveRequest(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        data: null,
        error: action.payload,
      };
    case CACHE_SYNC_RESET:
      return initialState;
    default:
      return state;
  }
};

export default cacheSyncReducer;
